// Веб-вклад модуля `voice-tutor` — голосовой репетитор.
//
// Роут в вебе — `/voice-tutor` (серверный манифест декларирует `/tutor/me` —
// путь из старого ТЗ, которого в дереве роутов нет; расхождение зафиксировано
// в baseline `module-registry-parity`).
//
// Сессия идёт поверх overlay-каркаса: сайдбар и bottom-nav на ней не
// монтируются. Глобальную панель репетитора там НЕ подавляем — так было до
// реестра, и это осознанно: голос и текст дополняют друг друга.

import { SECTION_ICONS, SECTION_TINT } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const voiceTutorWebManifest = {
	id: "voice-tutor",
	icon: SECTION_ICONS.voiceTutor,
	labelKey: "nav.voiceTutor",
	tint: SECTION_TINT.voiceTutor,
	routes: ["/voice-tutor"],
	overlayShellPrefixes: ["/voice-tutor/session"],

	// Баннер РАЗГРАНИЧИВАЕТ с соседями: раздел легко спутать с чатом репетитора
	// и с аудио-резюме (`docs/copy/ONBOARDING-COPY.md` §8.2). Вкладка справки —
	// «Инструменты»: именно там видно всех троих рядом.
	intro: {
		titleKey: "voice:intro.title",
		bodyKey: "voice:intro.body",
		bulletKeys: ["voice:intro.bullets.0", "voice:intro.bullets.1", "voice:intro.bullets.2"],
	},

	nav: [
		{
			key: "voice-tutor",
			to: "/voice-tutor",
			icon: SECTION_ICONS.voiceTutor,
			labelKey: "nav.voiceTutor",
			order: 70,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM voice_sessions WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	launch: [
		{
			key: "voiceTutor",
			icon: SECTION_ICONS.voiceTutor,
			tint: SECTION_TINT.voiceTutor,
			titleKey: "launcher.voiceTutor",
			hintKey: "launcher.voiceTutorHint",
			to: "/voice-tutor/new",
			order: 20,
		},
	],

	workspaceTools: [
		{ key: "voice", channel: "practice", icon: SECTION_ICONS.voiceTutor, steps: { 2: 30, 3: 10 } },
	],
} satisfies WebModuleManifest;
